import { AvatarColors } from "@certn/cascadia/components/avatar/types";
import { getAvatarColors } from "@certn/cascadia/components/avatar/utils";
import { cssToken } from "@certn/cascadia/utils";

import { _Avatar } from "./_Avatar";
import { AvatarBaseProps } from "./types";

type Props = Pick<
  AvatarBaseProps,
  "size" | "testID" | "displayVerifiedBadge"
> & {
  color?: AvatarColors;
};

export function IconPersonAvatar({
  color = "tofino",
  testID = "icon-person-avatar",
  ...props
}: Props) {
  const avatarColors = getAvatarColors(color);

  return (
    <_Avatar
      {...props}
      backgroundColor={avatarColors.backgroundColor}
      testID={testID}
    >
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.0001 11.8571C13.8585 11.8571 15.3651 10.3221 15.3651 8.42857C15.3651 6.53502 13.8585 5 12.0001 5C10.1416 5 8.63503 6.53502 8.63503 8.42857C8.63503 10.3221 10.1416 11.8571 12.0001 11.8571ZM12.0001 21C14.8276 21 17.354 19.6604 19 17.5715C17.354 15.4825 14.8275 14.1429 11.9999 14.1429C9.17242 14.1429 6.64602 15.4824 5 17.5713C6.64601 19.6604 9.17247 21 12.0001 21Z"
          fill={cssToken(avatarColors.iconColor)}
        />
      </svg>
    </_Avatar>
  );
}
